import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiStar, FiHeart } from 'react-icons/fi';
import { convertToINR } from '../utils/currency';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const defaultImage = 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=400&fit=crop';
  
  return (
    <Link
      to={`/products/${product._id}`}
      className="group card overflow-hidden stagger-item"
    >
      {/* Image Container */}
        <div className="relative h-64 overflow-hidden bg-[#FFF9D4]">
        <img
          src={product.images?.[0] || defaultImage}
          alt={product.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300"></div>
        
        {/* Wishlist button */}
        <button
          onClick={(e) => {
            e.preventDefault();
            // Add wishlist functionality
          }}
          className="absolute top-4 right-4 w-10 h-10 bg-[#FFF9D4] rounded-full flex items-center justify-center shadow-card opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-[#F27D16] hover:scale-110"
        >
          <FiHeart className="text-[#386646] hover:text-white" />
        </button>

        {/* Category badge */}
        <div className="absolute top-4 left-4 px-3 py-1 bg-[#FFF9D4] rounded-full text-xs font-medium text-[#386646] shadow-card">
          {product.category}
        </div>

        {/* Availability indicator */}
        {product.isAvailable && (
          <div className="absolute bottom-4 left-4 px-3 py-1 bg-[#F27D16] text-white rounded-full text-xs font-medium shadow-lg">
            Available Now
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-4 space-y-3">
        <h3 className="text-lg font-semibold text-[#386646] mb-2 line-clamp-1 group-hover:text-[#F27D16] transition-colors">
          {product.title}
        </h3>
        
        <p className="text-[rgba(45,45,45,0.7)] text-sm mb-3 line-clamp-2">
          {product.description}
        </p>

        {/* Seller info */}
        {product.seller && (
          <div className="flex items-center space-x-2 mb-3">
            <div className="w-6 h-6 rounded-full bg-[#F27D16] flex items-center justify-center text-white text-xs font-medium">
              {product.seller.name?.charAt(0).toUpperCase()}
            </div>
            <span className="text-sm text-[rgba(45,45,45,0.7)]">
              {product.seller.businessName || product.seller.name}
            </span>
          </div>
        )}

        {/* Rating */}
        <div className="flex items-center space-x-1 mb-3">
          <FiStar className="text-[#FCD06B] fill-current" />
          <span className="text-sm font-medium text-[#386646]">
            {product.rating?.toFixed(1) || '0.0'}
          </span>
          <span className="text-sm text-[rgba(45,45,45,0.7)]">
            ({product.totalReviews || 0})
          </span>
        </div>

        {/* Price */}
        <div className="flex items-center justify-between pt-3 border-t border-[#FCD06B]">
          <div>
            <p className="text-sm text-[rgba(45,45,45,0.7)]">From</p>
            <p className="text-xl font-bold text-[#F27D16]">
              ₹{convertToINR(product.pricePerDay).toLocaleString('en-IN')}
              <span className="text-sm font-normal text-[rgba(45,45,45,0.7)]">/day</span>
            </p>
          </div>
          
          <button
            onClick={(e) => {
              e.preventDefault();
              navigate(`/rent/${product._id}`);
            }}
            className="px-4 py-2 bg-[#F27D16] text-white rounded-[10px] text-sm font-medium hover:bg-[#D96D0E] hover:shadow-hover transition-all duration-300 transform group-hover:scale-105"
          >
            Rent Now
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
